import axios from "axios";
import authHeader from "./auth-header";

const API_URL = "http://210.3.12.74:9100/api/";
//const API_URL = "http://34.92.77.213:8080/api/test/";
const getPublicContent = () => {
  return axios.get(API_URL + "all");
};

const getUserBoard = () => {
  return axios.get(API_URL + "user", { headers: authHeader() });
};

const getModeratorBoard = () => {
  return axios.get(API_URL + "mod", { headers: authHeader() });
};

const getAdminBoard = () => {
  return axios.get(API_URL + "admin", { headers: authHeader() });
};

const getLog = () => {
  //return axios.get("http://34.92.77.213:8080/loglist");
  return axios.get(API_URL + "loglist");
};

const getRobotStatus = () => {
  //return axios.get("http://34.92.77.213:8080/loglist");
  return axios.get(API_URL + "robots");
};


const getCalendars = (ownerId) => {
  let headers = new Headers();

   
    headers.append('Accept', 'application/json');
    //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
    //headers.append('Origin','http://localhost:8080');
  return axios
    .get(API_URL + "calendars", {
      params: {'ownerId':ownerId}
    },
    {
      headers: headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const getCalendar = (calId) => {
  let headers = new Headers();

    
    headers.append('Accept', 'application/json');
    //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
    //headers.append('Origin','http://localhost:8080');
  return axios
    .get(API_URL + "calendar", {
      params: {'calId':calId}
    },
    {
      headers: headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const createCalendar = (ownerId, title) => {
  let headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
    headers.append('Origin','http://localhost:8080');
  return axios
    .post(API_URL + "calendar", {      
      ownerId,
      title
    },
    {
      headers: headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const addCalEvent = (calId,title, start, end, desc,repeating) => {
  let headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
    headers.append('Origin','http://localhost:8080');
  return axios
    .post(API_URL + "calendar/event", {
      calId,      
      title,
      start,
      end,
      desc,
      repeating
    },
    {
      headers: headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const updateCalEvent = (calId,eventId,title, start, end, desc,repeating) => {
  let headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
    headers.append('Origin','http://localhost:8080');
  return axios
    .put(API_URL + "calendar/event", {
      calId,    
      eventId,  
      title,
      start,
      end,
      desc,
      repeating
    },
    {
      headers: headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};


const deleteCalEvent = (calId, eventId) => {
  let headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
    headers.append('Origin','http://localhost:8080');
  return axios
    .delete(API_URL + "calendar/event", { data: { calId: calId, eventId,eventId }},
    {
      headers: headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

export default {
  getPublicContent,
  getUserBoard,
  getModeratorBoard,
  getAdminBoard,
  getLog,
  getRobotStatus,
  getCalendar,
  getCalendars,
  addCalEvent,
  updateCalEvent,
  deleteCalEvent
};
